import React from "react";
export default function Loader({ loaderStyle = "grid", gridCount = 12 }) {
  const gridArr = Array.from(Array(gridCount).keys());
  return (
    <>
      {loaderStyle === "grid" ? (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-6 lg:gap-7">
          {gridArr.map((index) => (
            <div
              key={index.toString()}
              className="flex-shrink-0 max-w-full w-[320px] 3xl:w-[390px] h-[320px] 3xl:h-[390px] border border-gray-300 rounded-lg shadow-offer-card"
            >
              <div className="flex flex-col h-full animate-pulse">
                <div className="flex-1 py-1 space-y-4 bg-gray-300 aspect-w-1 aspect-h-1"></div>
              </div>
            </div>
          ))}
        </div>
      ) : null}

      {loaderStyle === "fullScreenLoader" ? (
        <div className="fixed inset-0 z-[100000000] flex items-center justify-center w-full h-full text-white bg-dark slider-wrapper bg-opacity-90">
          <svg
            className="animate-spin"
            fill="#ffffff"
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 24 24"
          >
            <path d="M14 22c0 1.104-.896 2-2 2s-2-.896-2-2 .896-2 2-2 2 .896 2 2zm-2-22c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm10 10c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm-20.001 1c.551 0 1.001.449 1.001 1 0 .551-.449 1-1 1s-1-.448-1-1 .448-1 .999-1zm.002-1h-.002c-1.104 0-1.999.896-1.999 2 0 1.105.896 2 2 2h.001c1.104 0 1.999-.896 1.999-2s-.895-2-1.999-2zm16.999-7c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm0 14c1.104 0 2 .896 2 2s-.896 2-2.001 2c-1.103 0-1.999-.895-1.999-2s.896-2 2-2zm-14-13c.551 0 1 .448 1 1s-.449 1-1.001 1c-.551 0-.999-.448-.999-1s.449-1 1-1zm-.001-1c-1.104 0-1.999.896-1.999 2s.896 2 1.999 2h.001c1.104 0 2-.896 2-2s-.896-2-2.001-2zm.001 15c.551 0 1 .448 1 1s-.449 1-1.001 1c-.551 0-.999-.448-.999-1s.449-1 1-1zm-.001-1c-1.104 0-1.999.896-1.999 2s.896 2 1.999 2h.001c1.104 0 2-.896 2-2s-.896-2-2.001-2z" />
          </svg>
        </div>
      ) : null}
    </>
  );
}
